export type PcFormStatus = 'ready' | 'loading' | 'success' | 'error';

export type PcHtmlInputEvent = Event & {
  target: HTMLInputElement & EventTarget;
};

export const PC_FORM_INPUT_DEBOUNCE = 300;

export type PcRadioActiveColor = 'gold' | 'green' | 'red';
